import classNames from 'classnames';
import { Card, Col, Row, Badge } from "react-bootstrap";
import FalconCardHeader from "../../../../../components/common/FalconCardHeader";
import reporteTiempoStore from '../../../../../lib/store/reporte_tiempo_store';
import Flex from "../../../../../components/common/Flex";
import IconButton from "../../../../../components/common/IconButton";
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { obtenerIconoVehiculo } from "../../../../../components/common/google-maps-selector/IconosTabla";
import CardGraphOutHour from "../card-graph/graph-out-hour.js"

const Project = ({ project, isLast, onSelectVehicle, highlighted }) => {

    const { color, progress, totalAlerts, title } = project;

    // Determinar si es hexadecimal (empieza con #) o nombre de color Bootstrap
    const isHexColor = color.startsWith('#');

    // Mapear colores hexadecimales comunes a colores de Bootstrap (opcional)
    const mapHexToBootstrap = (hex) => {
        const colorMap = {
            '#0d6efd': 'primary',
            '#198754': 'success',
            '#ffc107': 'warning',
            '#dc3545': 'danger',
            '#0dcaf0': 'info',
            '#6c757d': 'secondary',
            '#adb5bd': 'light',
            '#212529': 'dark'
        };
        return colorMap[hex.toLowerCase()] || 'primary'; // Default a primary si no hay coincidencia
    };

    // Para el avatar y texto, usar estilo inline si es hex, o clases Bootstrap si es nombre
    const avatarStyle = isHexColor ? { backgroundColor: `${color}20` } : {}; // 20 = 12% opacidad para el fondo
    const textStyle = isHexColor ? { color: color } : {};

    // Clase para el avatar - usar clases Bootstrap solo si no es hexadecimal
    const avatarClass = isHexColor
        ? 'avatar-name rounded-circle'
        : `avatar-name rounded-circle bg-${color}-subtle`;

    // Clase para el texto - usar clases Bootstrap solo si no es hexadecimal
    const textClass = isHexColor
        ? 'fs-9'
        : `fs-9 text-${color.split('-')[1] || color}`;

    const style = {
        display: "-webkit-box",
        WebkitLineClamp: 1, // Limita a 2 líneas
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "normal",
    };
    return (
        <div>
            <Row
                className={classNames(
                    'position-relative align-items-center py-2 ps-3 g-0 flex-nowrap',
                    { 'border-bottom border-200': !isLast },
                    { 'text-danger fw-bold': highlighted }
                )} style={{ minWidth: '350px' }} href="#!" onClick={(e) => {
                    e.preventDefault();

                    onSelectVehicle(project.title);
                }}
            >
                {obtenerIconoVehiculo(project.tipo_vehiculo, project.color_vehiculo)}
                <Col className="py-1 px-3 ps-x1">
                    <Flex className="justify-content-between" >
                        <Row className='mx-0 px-0' style={{ width: '55%' }}>
                            <Flex className={classNames(
                                'm-0 p-0 align-items-center text-truncate flex-grow-1 flex-nowrap',
                                { 'fw-bold': highlighted }
                            )} tag="h6" style={{ ...style }}>
                                <a className={classNames('label-detail-card px-0 mx-0', {
                                    'fw-bold': highlighted
                                })}
                                    style={{ fontSize: '14px', ...style }}
                                    title={title}>
                                    {title}
                                </a>
                            </Flex>
                        </Row>
                        <Row className="justify-content-end text-end mx-2 g-0 flex-nowrap justify-content-between" style={{ width: '45%', minWidth: '200px' }} >

                            <div className='mx-2 text-start' style={{ width: '60px' }}>
                                <Badge pill bg="200">
                                    <div className="m-0 fs-10 fw-semibold text-primary">{(parseFloat(project.totalTime) + (parseFloat(project.totalStopped))).toFixed(0)} Horas</div>
                                </Badge>
                            </div>

                            <div className="justify-content-end d-flex flex-nowrap" style={{ width: '60%' }}>

                                <Badge pill bg="200" className="text-primary" style={{ width: '60px' }}>
                                    {progress}%
                                </Badge>

                                <a className="ms-2 text-800" >
                                    <FontAwesomeIcon icon={faArrowRight} />
                                </a>
                            </div>
                        </Row>
                    </Flex>
                </Col >
            </Row >
        </div >
    );
};

const CardVehiclesOutHour = ({ onSelectVehicle, highlightedVehicle, handleCleanFilters }) => {

    const store = reporteTiempoStore();

    const listVM = Object.values(store.listaReporte).map((vehicle, index) => ({
        id: index,
        title: vehicle.title,
        tipo_vehiculo: vehicle.tipo_vehiculo,
        color_vehiculo: vehicle.color_vehiculo,
        totalAlerts: vehicle.totalAlerts,
        totalRecords: vehicle.totalRecords, //Total filas  
        totalTime: vehicle.totalTime, //Tiempo total
        totalDistance: vehicle.totalDistance, //Distancia recorrida 
        totalIgnition: vehicle.totalIgnition, //Total encendido
        totalStopped: vehicle.totalStopped, //Total detenido
        totalOff: vehicle.totalOff, // Total Apagado
        totalLitters: vehicle.totalLitters, //Total litros 
        AllHours: vehicle.AllHours,
        progress: (((parseFloat(vehicle.totalTime) + parseFloat(vehicle.totalStopped)) / parseFloat(vehicle.AllHours)) * 100).toFixed(0),
        markers: vehicle.markers, //Detallado de puntos 
        color: ['primary', 'success', 'warning', 'danger', 'info'][index % 5] // Alternar colores
    }));

    const allHours = (listVM.reduce((a, v) => a = a + v.AllHours, 0));
    const globalIgnitionTime = (listVM.reduce((a, v) => a = a + v.totalTime, 0));
    const globalStopEngineTime = (listVM.reduce((a, v) => a = a + v.totalStopped, 0));
    const totalOn = parseFloat((globalIgnitionTime + globalStopEngineTime)).toFixed(0);

    const dataChart = Object.values(store.listaReporte).map((vehicle, index) => ({
        id: index,
        title: vehicle.title,
        target: (parseFloat(vehicle.totalTime) + parseFloat(vehicle.totalStopped)).toFixed(0),
        amount: (((parseFloat(vehicle.totalTime) + parseFloat(vehicle.totalStopped)) / parseFloat(vehicle.AllHours)) * 100).toFixed(0),
        color: ['#fc0296', '#0264fc', '#19fc02', '#f1fc02', '#fc0202'][index % 5] // Alternar colores
    }));

    let chartFiltered = dataChart;

    if (highlightedVehicle) {
        chartFiltered = dataChart.filter(w => w.title == highlightedVehicle);
    }

    return (
        <Card className="h-100">
            <FalconCardHeader
                title={highlightedVehicle ? `Uso fuera de horario laboral: ${highlightedVehicle}` : "Uso fuera de horario laboral"}
                light
                titleTag="h6"
                endEl={highlightedVehicle && (<IconButton onClick={handleCleanFilters} icon="times-circle" size="sm" variant="falcon-default">Remover filtro</IconButton>)}
            />

            <Card.Body className="p-0" >
                <Row className='mt-3'>
                    <Col md={4} lg={4} xs={12} className='mb-xxl-1 align-content-center'>
                        <div style={{ maxHeight: '253px' }}>
                            <CardGraphOutHour
                                key={"ChartVehicles"}
                                data={chartFiltered}
                                onSelectAlertType={onSelectVehicle}
                                total={totalOn}
                            />
                        </div>
                    </Col>
                    <Col md={8} lg={8} xs={12}>
                        <div className="overflow-auto" style={{ maxHeight: '253px' }}>
                            {listVM.map((project, index) => (
                                <Project
                                    project={project}
                                    isLast={index === listVM.length - 1}
                                    key={project.id || index}
                                    onSelectVehicle={onSelectVehicle}
                                    highlighted={highlightedVehicle === project.title}
                                />
                            ))}
                        </div>
                    </Col>
                </Row>
            </Card.Body>

            <Card.Footer className='py-0'>
                <Row className='px-1 pb-2 justify-content-end border-top border-200 pt-2'>
                    <Col md={6} className='text-start'>
                        <div className="fw-bold label-detail-card">
                            <a href='https://gps.quro.com.mx/Configuracion?windowId=2' size="sm" target="_blank" >
                                Ir a configuraci&oacute;n de horario
                            </a>
                        </div>
                    </Col>
                    <Col md={6} className='text-end'>
                        <div className="fw-bold label-detail-card"> Total de uso fuera de horarios laborales: {totalOn} hr(s) </div>
                    </Col>
                </Row>
            </Card.Footer>
        </Card>
    );
}

export default CardVehiclesOutHour;